var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAdditionalDocuments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_additional_documents",
    d: "M351.949,711.639h10.769a1.6,1.6,0,0,0,1.615-1.582V698.912h-3.769a1.6,1.6,0,0,1-1.615-1.582v-3.691h-7a1.6,1.6,0,0,0-1.616,1.582v14.836A1.6,1.6,0,0,0,351.949,711.639Zm2.154-10.582h4.642a.527.527,0,1,1,0,1.054H354.1a.527.527,0,1,1,0-1.054Zm0,2.109h6.461a.528.528,0,1,1,.046,1.055H354.1a.528.528,0,0,1-.046-1.055.34.34,0,0,1,.046,0Zm0,2.11h6.461a.527.527,0,1,1,0,1.054H354.1a.527.527,0,1,1,0-1.054Zm0,2.109h6.448a.528.528,0,1,1,.046,1.055h-6.5a.528.528,0,0,1-.046-1.055.34.34,0,0,1,.046,0Zm6.461-9.527h3.454l-3.992-3.91v3.382A.535.535,0,0,0,360.564,697.858Z",
    transform: "translate(-350.333 -693.639)",
    fill: "#74276b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAdditionalDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_additional_documents.8e22afdf228f7088778b3ec014bdf416.svg";